import { render } from "./PauseRestartmodal.vue?vue&type=template&id=3349369f&scoped=true"
import script from "./PauseRestartmodal.vue?vue&type=script&lang=js"
export * from "./PauseRestartmodal.vue?vue&type=script&lang=js"

import "./PauseRestartmodal.vue?vue&type=style&index=0&id=3349369f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3349369f"]])

export default __exports__